import { BaseService } from "./BaseService";
import { Injectable } from "@angular/core";
import { APIServiceConnector } from "./APIServiceConnector";
import { AppSettings } from "../Library/AppSettings";
import { QuestionSetLookupResponse, BaseResponse, QuestionSetDetailResponse, SimpleResponse, StaffQuestionaireTemplate } from "../Models/ResponseModels";
import { QuestionSetSearch, AnswerOption, QuestionSetInsertUpdateRequest, QuestionInsertUpdateViewModel, ChangeQuestionnaireStatusRequest } from "../Models/RequestModels";
import { AnswerTypes, QuestionSetStatus } from "../Models/EnumModels";
import { UUID } from "angular2-uuid";
import { TranslateService } from "@ngx-translate/core";
import * as _ from 'lodash';

@Injectable()
export class StaffHealthDataService extends BaseService {

    constructor(public apiService: APIServiceConnector, public translate: TranslateService) {
        super();
        this.BaseURL = AppSettings.URL_Masters;
    }

    InsertUpdateStaffHealthQuestions(req: QuestionSetInsertUpdateRequest): Promise<BaseResponse> {
        return this.apiService.postAPI(this.BaseURL, 'StaffHealth/InsertUpdateStaffHealthQuestions', req, true)
    }

    GetQuestionaireById(propertyId: number, questionId: number, trackLoading = false): Promise<QuestionSetDetailResponse> {
        return this.apiService.getAPI(this.BaseURL, `StaffHealth/GetQuestionaireById?propertyId=${propertyId}&questionId=${questionId}`, trackLoading)
            .then(data => {
                if (data.HasError) {
                    return data;
                }
                const questions = (data.Result && data.Result.Questions);
                if (questions) {
                    data.Result.Questions = questions.map(QuestionInsertUpdateViewModel.updateAnswer)
                }

                let template = data.Result && data.Result.StaffQuestionaireTemplate;
                if (template) {
                    template = this.SetStatusIcon(template);
                    data.Result.StaffQuestionaireTemplate = this.SetDateTimeFormat(template);
                }

                return data;
            });
    }

    GetQuestionairesForProperty(propertyId: number, trackLoading: boolean): Promise<QuestionSetLookupResponse> {
        return this.apiService.getAPI(this.BaseURL, `StaffHealth/GetQuestionairesForProperty?propertyId=${propertyId}`, trackLoading)
            .then(data => {
                if (data.HasError) {
                    return data;
                }
                const templates = data.Result && data.Result.StaffQuestionaireTemplates || [];
                const counts = templates.length && data.Result.QuestionaireReponseCounts;
                if (templates.length) {
                    const indexedCounts = counts && _.keyBy(counts, 'QuestionaireId');
                    data.Result.StaffQuestionnaireTemplates = templates.map(t => {
                        t = this.SetStatusIcon(t);
                        t = this.SetDateTimeFormat(t);

                        t.ExecutionCount = (indexedCounts && indexedCounts[t.Id]) ? indexedCounts[t.Id].ResponseCount : 0;
                        return t;
                    });
                }


                return data;
            });
    }

    ChangeQuestionaireStatus(req: ChangeQuestionnaireStatusRequest): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, 'StaffHealth/ChangeQuestionaireStatus', req, true);
    }

    SetDateTimeFormat(template: StaffQuestionaireTemplate) {
        if (template) {
            template.CreatedOnDate = template.CreatedOnUtc && new Date(template.CreatedOnUtc);
            const activatedDate = template.LastActivatedDateTimeUTC; // || template['LastActivatedDateTime'];
            template.LastActivatedDate = activatedDate && new Date(activatedDate);
            const deactivatedDate = template.LastDeactivatedDateTimeUTC; // || template['LastDeactivatedDateTime'];
            template.LastDeactivatedDate = deactivatedDate && new Date(deactivatedDate);
        }
        return template;
    }

    SetStatusIcon(template: StaffQuestionaireTemplate) {
        if (template) {
            let statusClass = '';
            switch (template.Status) {
                case QuestionSetStatus.Active:
                    statusClass = 'status-OPN';
                    break;
                case QuestionSetStatus.Disabled:
                    statusClass = 'status-CLS';
                    break;
                case QuestionSetStatus.Pending:
                    //statusClass = 'status-SNL';
                    statusClass = 'status-CLS';
                    break;
            }
            template.StatusClass = statusClass;
        }
        return template
    }


    GetAnswerResponses(): AnswerOption[] {
        return [
            {
                id: 'response-type-text',
                label: this.translate.instant('LBL.RESPONSE_TEXT'),
                type: AnswerTypes.Text,
                attributes: {},
                values: null,
            },
            {
                id: 'response-type-numeric',
                label: this.translate.instant('LBL.RESPONSE_NUMERICAL'),
                type: AnswerTypes.Numerical,
                attributes: {
                    unit: '',
                    min: null,
                    max: null
                },
                values: null,
            },
            {
                id: 'response-type-bool',
                label: this.translate.instant('LBL.RESPONSE_BINARY'),
                type: AnswerTypes.OptionalBool,
                attributes: {},
                values: [{ value: 0, original: 'PH.PH_FAIL', label: this.translate.instant('LBL.FAIL_LABEL'), uuid: UUID.UUID() }, { value: 1, original: 'PH.PH_PASS', label: this.translate.instant('LBL.PASS_LABEL'), isValid: true, uuid: UUID.UUID() }],
            },
            {
                id: 'response-type-radio',
                label: this.translate.instant('LBL.RESPONSE_RADIO'),
                type: AnswerTypes.Radio,
                attributes: {},
                values: [],
            },
            {
                id: 'response-type-checkbox',
                label: this.translate.instant('LBL.RESPONSE_CHECKBOX'),
                type: AnswerTypes.Checkbox,
                attributes: {},
                values: [],
            },
            {
                id: 'response-type-rating',
                label: this.translate.instant('LBL.RESPONSE_RATING'),
                type: AnswerTypes.Rating,
                attributes: {},
                values: [1, 2, 3, 4, 5].map(num => ({ value: num, original: '' + num, label: '' + num, uuid: UUID.UUID() })),
            }
        ]
    }

}
